import { EmploymentOccupation } from "../../lead-api";
import { type OccupationMenuItem } from "../Employment.types";

const tKey = "inputs.employment.";

export const occupationMenuItemsID: OccupationMenuItem[] = [
  {
    label: tKey + EmploymentOccupation.Employed.toLowerCase(),
    value: EmploymentOccupation.Employed,
  },
  {
    label: tKey + EmploymentOccupation.SelfEmployed.toLowerCase(),
    value: EmploymentOccupation.SelfEmployed,
  },
  {
    label: tKey + EmploymentOccupation.BusinessOwner.toLowerCase(),
    value: EmploymentOccupation.BusinessOwner,
  },
  {
    label: tKey + EmploymentOccupation.Freelancer.toLowerCase(),
    value: EmploymentOccupation.Freelancer,
  },
  {
    label: "inputs.employment.not_employed",
    value: EmploymentOccupation.Unemployed,
  },
  {
    label: tKey + EmploymentOccupation.Retired.toLowerCase(),
    value: EmploymentOccupation.Retired,
  },
  {
    label: tKey + EmploymentOccupation.Student.toLowerCase(),
    value: EmploymentOccupation.Student,
  },
  {
    label: tKey + EmploymentOccupation.Other.toLowerCase(),
    value: EmploymentOccupation.Other,
  },
];
